import { Button, Drawer } from "antd";
import "./MobileAppHeader.scss";
import Logo from "../Logo";
import { useRecoilState } from "recoil";
import { memberState } from "../../state/atoms";
import UserBadge from "../UserBadge";
import { LocationDto, MemberDto } from "../../generated/dashboard-client";
import { useState } from "react";
import MobileAppAside from "./MobileAppAside";
import MobileAccountAside from "./MobileAccountAside";
import SideNavIcon from "../icons/SideNavIcon";

export interface MobileAppHeaderProps {
  activeLocation: LocationDto;
  cartCount: number;
  setCartCount: any;
  users: MemberDto[];
}

export default function MobileAppHeader({ activeLocation, cartCount, setCartCount, users }: MobileAppHeaderProps) {
  const [member] = useRecoilState(memberState);
  const [isAccountDrawerVisible, setAccountDrawerVisible] = useState(false);
  const [isAsideDrawerVisible, setAsideDrawerVisible] = useState(false);

  function toggleAccountDrawer() {
    setAccountDrawerVisible(!isAccountDrawerVisible);
  }

  function onCloseAccountDrawer() {
    setAccountDrawerVisible(false);
  }

  function toggleAsideDrawer() {
    setAsideDrawerVisible(!isAccountDrawerVisible);
  }

  function onCloseAsideDrawer() {
    setAsideDrawerVisible(false);
  }

  return (
    <header className={"mobile-main"}>
        <Button type={"link"} className={"aside-toggle"} onClick={toggleAsideDrawer}>
            <SideNavIcon/>
        </Button>
        <Drawer 
            visible={isAsideDrawerVisible}
            onClose={onCloseAsideDrawer}
            width={'100%'}
            placement={'left'}
            className={'mobile-app-aside'}
        >
            <MobileAppAside
                activeLocation={activeLocation}
                closeDrawer={onCloseAsideDrawer}
                cartCount={cartCount}
                setCartCount={setCartCount}
                users={users} />
        </Drawer>


        <Logo activeLocation={activeLocation} />
        
        <Button type={"link"} className={`account-toggle ${!member.id ? 'hidden' : ''}`} onClick={toggleAccountDrawer}>
            <UserBadge name={member.name} />
        </Button>
        <Drawer 
            visible={isAccountDrawerVisible}
            onClose={onCloseAccountDrawer}
            width={'100%'}
            className={'mobile-account-aside'}
        >
            <MobileAccountAside 
              closeDrawer={onCloseAccountDrawer} />
        </Drawer>
    </header>
  );
}
